import { atom } from 'jotai';

export const fullscreenState = atom(false);
